export default __webpack_public_path__ + "media/rafael.aefa8616.jpg";